<template>
  <div class="pt20">
    <div class="row" v-if="isActive || isFilled">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-2 col-sm-2 col-md-1">
            <div
              class="number-circle lh35 cl-white brdr-circle align-center weight-700"
              :class="{ 'bg-cl-th-accent' : isActive, 'bg-cl-tertiary' : !isActive }"
            >
              4
            </div>
          </div>
          <div class="col-xs-8 col-sm-8 col-md-10">
            <div class="row">
              <div class="col-xs-12" :class="{ 'cl-bg-tertiary' : !isFilled && !isActive }">
                <h3 class="m0">
                  {{ $t('Set Address') }}
                </h3>
              </div>
            </div>
          </div>
          <div class="col-xs-2 col-sm-2 col-md-1 end-xs">
            <i data-v-0c2f6ec6="" class="material-icons arrow-i"
               :class="{ 'active' : isActive }"
            >keyboard_arrow_right</i>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt15" v-if="isActive">
      <!-- Cards -->
      <address-list v-if="currentUser && addresses.length > 0" class="shipping-block-list-checkout" />
      <!---->

      <div class="col-xs-12" v-if="currentUser && addresses.length > 0">
        <div class="shipping-block-actions add-btn">
          <button class="shipping-block-actions-btn" @click="toggleNewAddressForm">
            {{ !shippingDetailsState.showNewAddressForm ? $t('Add a new address') : $t('Close') }}
          </button>
        </div>
      </div>

      <!-- New Address -->
      <div class="col-xs-12" v-if="shippingDetailsState.showNewAddressForm">
        <address-form @updated="shippingAddressUpdated" :other-receiver="otherReceiver" :stored-address="shipping" />
        <template v-if="currentUser">
          <base-checkbox
            v-if="hasShippingDetails"
            class="col-xs-12 left-pos"
            id="saveToMyAddressesCheckbox"
            v-model="saveToMyAddress"
            @change="saveNewAddressFlag"
          >
            {{ $t('Save to my Shipping Addresses') }}
          </base-checkbox>
        </template>
      </div>
    </div>
    <!-- -->

    <div class="row " v-if="isActive">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12 col-md-8 my15" style="margin: auto">
            <button-full
              data-testid="shippingSubmit"
              @click.native="sendDataToCheckout"
              :disabled="$v.shipping.$invalid"
            >
              <img src="../../../../assets/icons/icon-5.png" class="mr10" alt="Login"> {{ $t('Continue to delivery time') }}
            </button-full>
          </div>
        </div>
      </div>
    </div>
    <div class="row " v-if="!isActive && isFilled">
      <div class="col-xs-12">
        <div class="row fs16 brdr-bottom-1 brdr-cl-bg-secondary">
          <div class="col-xs-12">
            <div class="lh30 flex end-xs" v-if="!isActive && isFilled">
              <a href="#" class="cl-tertiary flex" @click.prevent="edit" v-if="!isCheckout">
                <span class="pr5 h6">
                  {{ $t('Edit') }}
                </span>
                <i class="material-icons cl-tertiary">edit</i>
              </a>
            </div>
          </div>
          <div class="col-xs-12 h4 mb15 bg-cl-secondary" data-testid="shippingToAddressSummary">
            <p>
              {{ assembleAddress }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { unicodeAlphaNum } from '@vue-storefront/core/helpers/validators'
import i18n from '@vue-storefront/i18n'
import updateObject from '@vue-storefront/core/scripts/utils/update-object'
import checkoutInitialState from '@vue-storefront/core/modules/checkout/store/checkout/initial-state'

import { mapState, mapGetters, mapActions } from 'vuex'
import BaseCheckbox from 'theme/components/core/blocks/Form/BaseCheckbox'
import ButtonFull from 'theme/components/theme/ButtonFull'
import AddressList from 'theme/components/core/blocks/MyAccount/ShippingDetails/AddressList'
import AddressForm from 'theme/components/core/blocks/Form/Customer/Shipping/AddressForm'

export default {
  components: {
    ButtonFull,
    BaseCheckbox,
    AddressList,
    AddressForm
  },
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  },
  beforeDestroy () {
    this.$bus.$off('user-after-loggedin', this.getActiveShippingAddressId)
    this.$bus.$off('address-list-address-changed', this.addressChanged)
  },
  beforeMount () {
    this.$bus.$on('user-after-loggedin', this.getActiveShippingAddressId)
    this.$bus.$on('address-list-address-changed', this.addressChanged)
  },
  data () {
    return {
      saveToMyAddress: false, // save new Address to Address Book
      isFilled: false,
      myAddressDetails: {
        firstname: '',
        lastname: '',
        country: '',
        state: '',
        city: '',
        street: '',
        house: '',
        apartment: '',
        postcode: '',
        telephone: '',
        comment: '',
        longitude: '',
        latitude: '',
        api_details: ''
      },
      otherReceiver: false
    }
  },
  async mounted () {
    if (!this.currentUser) {
      this.updateShippingDetailsState({
        shipToMyAddress: false,
        showNewAddressForm: true
      })
      // Pre-fill from the guest address already picked via the header address
      // selector (localStorage 'shop/user/guest-addresses'), same call the
      // normal checkout flow makes - Anywhere used to leave the form blank
      // even when a guest had already selected an address elsewhere.
      this.getGuestShippingDetails()
    }

    if (this.currentUser && (!this.addresses || !this.addresses.length)) {
      await this.loadAddressList();
    }

    this.getActiveShippingAddressId();
  },
  watch: {
    'shippingDetailsState.shipToMyAddress': {
      handler () {
        this.useMyAddress()
      }
    },
    shipping: {
      deep: true,
      handler: function () {
        this.setMyAddressDetails();
      }
    }
  },
  methods: {
    ...mapActions({
      saveFirstUserShippingDetails: 'checkout/saveFirstUserShippingDetails',
      setAddNewAddress: 'checkout/setAddNewAddress',
      makeDefault: 'address/makeDefault',
      updateShippingDetailsState: 'shipping/updateShippingDetailsState',
      loadAddressList: 'address/loadList',
      saveShippingDetails: 'checkout/saveShippingDetails',
      getGuestShippingDetails: 'checkout/getGuestShippingDetails'
    }),
    addressChanged (address) {
      this.saveShippingDetails(updateObject(this.shipping, {
        ...address
      }));
      this.makeDefault({ address_id: address.id })
        .then((res) => {
          this.$bus.$emit('checkout-after-shippingDetails', res);
          this.updateShippingDetailsState({
            shipToMyAddress: true,
            showNewAddressForm: false
          })
        })
        .catch(() => {
          this.$store.dispatch('notification/spawnNotification', {
            type: 'error',
            message: i18n.t('Error is happened during making address default!'),
            action1: { label: i18n.t('OK') }
          })
        })
    },
    edit () {
      if (this.isFilled) {
        this.$bus.$emit('pickup-checkout-before-edit', 'shipping')
      }
    },
    sendDataToCheckout () {
      if (!this.shipping.longitude || !this.shipping.latitude || !this.shipping.api_details) {
        this.$bus.$emit('scroll-to-the-address-form');
        this.$store.dispatch('notification/spawnNotification', {
          type: 'error',
          message: i18n.t('Address is not valid!'),
          action1: { label: i18n.t('OK') },
          action2: { label: i18n.t('Edit'),
            action: () => {
              this.$router.push({ name: 'my-shipping-details' }, () => {
                setTimeout(() => {
                  this.$bus.$emit('customer-display-shipping-address-form', { type: 'edit', item: this.shipping })
                }, 100)
              })
            } }
        })

        return
      }
      this.$bus.$emit('pickup-checkout-after-shippingToDetails', this.shipping, this.$v);
      this.isFilled = true
    },

    hasShippingDetails () {
      if (this.currentUser) {
        return this.setMyAddressDetails();
      }

      return false
    },
    setMyAddressDetails () {
      if (!this.currentUser) {
        return false
      }

      if (!this.addresses.length) {
        const defaultLocation = this.$store.getters['locations/getLocations'].find(location => location.code === this.currentUser.default_location_code);
        this.myAddressDetails.customer_id = this.currentUser.id
        this.myAddressDetails.firstname = this.currentUser.firstname
        this.myAddressDetails.lastname = this.currentUser.lastname
        this.myAddressDetails.telephone = this.currentUser.telephone
        this.myAddressDetails.location_code = this.currentUser.default_location_code
        this.myAddressDetails.country = 'UA'
        this.myAddressDetails.city = defaultLocation ? defaultLocation.name : ''
        this.updateShippingDetailsState({
          shipToMyAddress: false,
          showNewAddressForm: true
        })

        return true
      }

      if (this.defaultAddress) {
        // search default_address from customers table
        this.myAddressDetails = JSON.parse(JSON.stringify(this.defaultAddress))
        return true
      }

      // has addresses but none of them are marked as default
      this.myAddressDetails = this.addresses[0]
      this.updateShippingDetailsState({
        shipToMyAddress: true,
        showNewAddressForm: false
      })
      this.useMyAddress()

      return true
    },

    useMyAddress () {
      if (this.shippingDetailsState.shipToMyAddress) {
        this.saveShippingDetails(updateObject(this.shipping, {
          firstName: this.myAddressDetails.firstname,
          lastName: this.myAddressDetails.lastname,
          country: this.myAddressDetails.country,
          state: this.myAddressDetails.state,
          city: this.myAddressDetails.city,
          longitude: this.myAddressDetails.longitude,
          latitude: this.myAddressDetails.latitude,
          api_details: this.myAddressDetails.api_details,
          street: this.myAddressDetails.street,
          house: this.myAddressDetails.house,
          apartment: this.myAddressDetails.apartment,
          postcode: (this.myAddressDetails.postcode && this.myAddressDetails.postcode === '') ? '' : this.myAddressDetails.postcode,
          phoneNumber: this.myAddressDetails.telephone,
          comment: (this.myAddressDetails.comment && this.myAddressDetails.comment === '') ? '' : this.myAddressDetails.comment
        }));
      } else {
        this.saveShippingDetails(updateObject(checkoutInitialState.shippingDetails, {
          firstName: this.myAddressDetails.firstname,
          lastName: this.myAddressDetails.lastname,
          phoneNumber: this.myAddressDetails.telephone
        }));
      }
    },

    getActiveShippingAddressId () {
      const activeShippingAddressId = this.searchActiveShippingAddressId();
      if (activeShippingAddressId) {
        this.changeActiveShippingAddress(activeShippingAddressId)
      }
    },
    searchActiveShippingAddressId () {
      if (!this.currentUser) {
        return false
      }
      if (this.addresses.length) {
        return this.defaultAddress ? this.defaultAddress.id : this.addresses[0].id
      }

      return false
    },
    changeActiveShippingAddress (id) {
      this.saveToMyAddress = false
      this.setAddNewAddress(this.saveToMyAddress)
      let defaultAddress = this.addresses.find(address => address.id === id)
      if (!defaultAddress) {
        defaultAddress = this.defaultAddress
      }
      if (defaultAddress) {
        this.saveShippingDetails(updateObject(this.shipping, {
          ...defaultAddress
        }))
        this.myAddressDetails = {...defaultAddress}
        this.makeDefault({ address_id: id })
          .then((res) => {
            this.$bus.$emit('checkout-after-shippingDetails', res);
            this.updateShippingDetailsState({
              shipToMyAddress: true,
              showNewAddressForm: false
            })
          })
          .catch(() => {
            this.$store.dispatch('notification/spawnNotification', {
              type: 'error',
              message: i18n.t('Error is happened during making address default!'),
              action1: { label: i18n.t('OK') }
            })
          })
      }
      this.useMyAddress()
    },
    toggleNewAddressForm () {
      if (!this.shippingDetailsState.showNewAddressForm) {
        this.updateShippingDetailsState({
          shipToMyAddress: false,
          showNewAddressForm: true
        })
      } else {
        this.getActiveShippingAddressId();
      }
      this.useMyAddress()
    },
    saveNewAddressFlag () {
      this.setAddNewAddress(this.saveToMyAddress)
    },
    shippingAddressUpdated (shipping) {
      this.saveShippingDetails(updateObject(this.shipping, {
        ...shipping
      }))
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.user.current,
      shipping: state => state.checkout.shippingDetails
    }),
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      currentLocation: 'locations/getActiveLocation',
      addresses: 'address/getAddressList',
      defaultAddress: 'address/getDefaultAddress',
      shippingDetailsState: 'shipping/getShippingDetailsState',
    }),
    assembleAddress () {
      let address = `${this.shipping.street}, ${this.shipping.house}`
      if (this.shipping.apartment) {
        address += `, ${this.$t('кв. ')}${this.shipping.apartment}`
      }
      return address
    },
    isCheckout () {
      return this.$route.name === 'checkout';
    }
  },
  validations () {
    let validations = {
      shipping: {}
    };
    if (this.shippingDetailsState.showNewAddressForm) {
      validations.shipping.street = {
        required,
        unicodeAlphaNum
      };
      validations.shipping.house = {
        required,
        unicodeAlphaNum
      };
    }
    return validations;
  }
}
</script>
<style scoped lang="scss">
  .autocomplete {
    width: 100%;
    height: 40px;
    background-color: #ffffff;
    padding-top: 0!important;
    &::placeholder{
      margin-right: 10px;
    }
  }

  .base-input-additional-text {
    min-height: 3rem;
  }
  /*.green-color{*/
  /*color: #11bb2e;*/
  /*}*/
  .shipping-block-list-item-details {
    text-align: left;
  }
  .left-pos {
    text-align: left;
    margin-bottom: 20px;
  }
  .shipping {
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 576px) {
      padding: 0 20px;
    }

    &-line {
      height: 60px;
      margin-bottom: 20px;

      display: flex;
      justify-content: space-between;
      align-items: center;

      &.activated {
        height: 60px;
        margin-bottom: 20px;
      }

      @media only screen and (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
      }

      @media only screen and (max-width: 576px) {
        height: 0px;
        margin-bottom: 0;
      }

      &-title {
        margin: 0;

        color: #111;
        font-size: 20px;
        font-weight: 600;

        @media only screen and (max-width: 576px) {
          display: none;
        }
      }

      &-link {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;

        @media only screen and (max-width: 768px) {
          font-size: 14px;
        }

        &-icon {
          padding-left: 10px;
        }
      }
    }

    &-block {

      &-list {
        display: flex;
        flex-wrap: wrap;
        gap: 24px;

        &-item {
          height: 160px;
          max-width: calc(50% - 8px);
          flex: 1 1 calc(50% - 16px);

          display: flex;
          flex-direction: column;
          justify-content: space-between;

          position: relative;

          border: 1px solid #ebebeb;
          border-radius: 5px;

          @media only screen and (max-width: 991px) {
            flex: 1 1 100%;
            max-width: none;
          }
          &:hover {
            cursor: pointer;
            background: #F1F1F1;
          }

          &.active {
            border-color: #11bb2e;

            & .shipping-block-list-item-actions {
              justify-content: space-between;
            }

            & .shipping-block-list-item-actions-link:first-child:before {
              display: none;
            }
          }

          &-details {
            margin-top: 10px;
            margin-left: 10px;
            padding-left: 25px;

            position: relative;

            display: flex;
            flex-direction: column;

            &:before {
              width: 15px;
              height: 18px;

              position: absolute;
              top: 0;
              left: 0;

              margin: auto;
              content: '';

              background-image: url('../../../../assets/account/icon-location-green.png');
              background-position: center;
              background-size: 15px 18px;
              background-repeat: no-repeat;
            }

            &-text {
              font-size: 14px;

              & + & {
                margin-top: 10px;
              }
            }
          }

          &-actions {
            display: flex;
            justify-content: flex-start;
            align-items: flex-end;

            &-link {
              margin-bottom: 8px;

              color: #11bb2e;
              font-size: 12px;

              &:first-child {
                position: relative;
                padding-left: 15px;
                padding-right: 14px;

                &:before {
                  width: 1px;
                  height: 13px;

                  position: absolute;
                  top: 0;
                  right: 0;
                  bottom: 0;

                  margin: auto;
                  content: '';

                  background: #ebebeb;
                }
              }

              &:last-child {
                padding-left: 14px;
              }

              &:hover {
                cursor: pointer;
                text-decoration: underline;
              }
            }

            &-text {
              padding: 8px 16px;

              color: #fff;
              font-size: 12px;
              font-weight: 600;

              border-top-left-radius: 5px;
              border-bottom-right-radius: 5px;

              background-color: #11bb2e;
            }
          }

          &-image {
            width: 18px;
            height: 20px;

            position: absolute;
            top: 10px;
            right: 10px;

            margin: auto;

            &:hover {
              cursor: pointer;
            }
          }
        }

        &-checkout {
          margin: 0 8px 24px;
        }
      }

      &-nothing {
        width: 100%;
        margin-top: 10px;
        text-align: center;

        &-text {
          color: #111;
          font-size: 18px;
          font-weight: 400;
        }
      }

      &-actions {
        display: flex;
        justify-content: center;

        @media only screen and (max-width: 576px) {
          margin-top: 20px;
        }

        &.add-btn {
          justify-content: flex-start;

          & .shipping-block-actions-btn {
            padding-left: 98px;
            margin-bottom: 20px;

            background-image: url('../../../../assets/account/icon-location-active.png');
            background-position: 70px center;
            background-size: 15px 18px;
            background-repeat: no-repeat;

            @media only screen and (max-width: 768px) {
              width: 100%;
              padding: 16px 0 16px 20px;
              background-position: 50px center;
            }

            @media only screen and (max-width: 576px) {
              width: auto;
              padding: 16px 84px 16px 98px;
              background-position: 70px center;
            }

            @media only screen and (max-width: 371px) {
              width: 100%;
              padding: 16px 0;
              background-size: 0;
            }
          }
        }

        &-btn {
          width: auto;
          padding: 16px 84px;

          color: #fff;
          font-size: 16px;
          font-weight: 400;

          background-color: #11bb2e;
          border: none;
          border-radius: 5px;

          outline: none;

          &:hover {
            cursor: pointer;
            background-color: rgba(17, 187, 46, 0.8);
          }
        }
      }

      &-field {
        padding: 0;
      }
    }
  }
</style>
